import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) => {
  return (
    data.map(({ fieldName, placeholder, name, formType, validation, className, options, usedFileType, note, loadOptions, imageDimension }) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      usedFileType: usedFileType,
      loadOptions: loadOptions,
      note: note,
      imageDimension: imageDimension
    }))
  )
}

export const fields: any = {
  topHeader: mapFields(drilldownData["topHeader"]),
  menuHeader: mapFields(drilldownData["menuHeader"]),
  categoryBanner: mapFields(drilldownData["categoryBanner"]),
};